import React from 'react';
import Shop from '../shop';

export default class ShopRedirect extends React.Component {
  componentDidMount() {
    const oldBumpCategory = this.props.match.params.oldBumpCategory || '';
    const { parentCategory } = this.props.match.params;
    const { childCategory } = this.props.match.params;
    const { sort } = this.props.match.params;

    let newPath = window.location.pathname;

    const bestSellerRegex = /bestseller/i;
    if (bestSellerRegex.test(oldBumpCategory)) {
      newPath = '/shop/best-sellers';
    } else if (parentCategory && !childCategory) {
      const parent = parentCategory.toLowerCase();
      newPath = `/shop/${parent}`;
    } else if (sort) {
      const parent = parentCategory.toLowerCase();
      const child = childCategory.toLowerCase();
      newPath = `/shop/${parent}/${child}/${sort}`;
    } else if (childCategory) {
      const parent = parentCategory.toLowerCase();
      const child = childCategory.toLowerCase();
      newPath = `/shop/${parent}/${child}`;
    }

    // Only set a new path if the path changed.
    if (newPath !== window.location.pathname) {
      this.props.history.push({
        pathname: newPath,
        search: window.location.search,
      });
    }
  }

  render() {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Shop {...this.props} />;
  }
}
